export enum LogSystem {
  firebase = 'firebase',
  sentry = 'sentry',
  metaPixel = 'metaPixel'
}
